import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import { Namespace, Ontologies, Ontology, Concept, SparqlVariable } from '../../model/models'
import { ServerState } from './state'
import { RootState } from '../state';
import { getStoreAccessors } from 'vuex-typescript';

type Context = ActionContext<ServerState, RootState>;

var emptyConcept = new Concept()
emptyConcept.concept = new SparqlVariable()

var emptyOntology  = new Ontology()
emptyOntology.skos= false
emptyOntology.id = ''
emptyOntology.name = ''
emptyOntology.namespace = ''
emptyOntology.topConcepts = []


const state:ServerState = {
  namespaces:[],
  ontologies:[], 
  ontology:emptyOntology,
  concept:emptyConcept
}



// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations:MutationTree<ServerState> = {
  addNamespace (state, ns:Namespace) {
    state.namespaces.push(ns)
  },
  namespaces (state, ns:Namespace[]) {
    state.namespaces = ns
  },
  delNamespace (state, ns:Namespace) {
    let index = state.namespaces.indexOf(ns)
    state.namespaces.splice(index, 1)
  },
  ontologies (state, s:Ontology[]) { state.ontologies = s },
  ontology (state, s:Ontology) { state.ontology = s },
  concept (state, s:Concept) { state.concept = s },
  resetOntology (state) { state.ontology = emptyOntology }
}  
// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions:ActionTree<ServerState,any> = {
}
 
// getters are functions
const getters:GetterTree<ServerState,any> = {
  namespaces: (state:ServerState) => { return state.namespaces },
  ontologies: (state:ServerState) => { return state.ontologies },
  ontology: (state:ServerState) => { return state.ontology },
  concept: (state:ServerState) => { return state.concept }
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export const serverStore = {
  state,
  getters,
  actions,
  mutations
}

const { commit, read, dispatch } = getStoreAccessors<ServerState, RootState>('')

// export const actionAddTimeEntry = dispatch(actions.addTimeEntry);
// export const actionDelTimeEntry = dispatch(actions.delTimeEntry);



// WEBPACK FOOTER //
// ./src/store/servers/store.ts